import { carApi, userApi } from '../../api';
import { socket } from '../../api/config';

export const RESET_SELECTED_PVZ = 'META:RESET_SELECTED_PVZ';
export const SOCKET_CONNECTED = 'META:SOCKET_CONNECTED';
export const SET_USER_AUTH = 'META:SET_USER_AUTH';
export const PHONE_REQUEST_AUTH_FAILED = 'META:PHONE_REQUEST_AUTH_FAILED';
export const SET_USER_NEW_ORDER = 'META:SET_USER_NEW_ORDER';
export const SET_RECENT_DIALOG = 'META:SET_RECENT_DIALOG';
export const SET_SELECTED_PVZ = 'META:SET_SELECTED_PVZ';
export const SET_CAR_BRAND = 'META:SET_CAR_BRAND';
export const GET_CAR_BRANDS = 'META:GET_CAR_BRANDS';
export const SET_CAR_BRANDS = 'META:SET_CAR_BRANDS';
export const MESSAGE_UNBLOCK = 'META:MESSAGE_UNBLOCK';
export const MESSAGE_BLOCK = 'META:MESSAGE_BLOCK';
export const SET_OPEN_KEYBOARD = 'META:SET_OPEN_KEYBOARD';
export const AUTH_REQUEST = 'META:AUTH_REQUEST';
export const TOGGLE_AUTH_MODAL = 'META:TOGGLE_AUTH_MODAL';
export const TOGGLE_LOGOUT_MODAL = 'META:TOGGLE_LOGOUT_MODAL';
export const LOGOUT = 'META:LOGOUT';
export const SET_AUTH_CODE_IS_VALID = 'META:SET_AUTH_CODE_IS_VALID';
export const RESET_AUTH_CODE_IS_VALID = 'META:RESET_AUTH_CODE_IS_VALID';
export const SET_ORDERS = 'META:SET_ORDERS';
export const VERIFY_AUTH_CONFIRM = 'META:VERIFY_AUTH_CONFIRM';
export const SET_CURRENT_MOBILE_LAYOUT = 'META:SET_CURRENT_MOBILE_LAYOUT';
export const SET_ARCHIVE_DIALOG_FIXED = 'META:SET_ARCHIVE_DIALOG_FIXED';

const actions = {
  onSocketConnect: {
    handle: SOCKET_CONNECTED,
    event: 'connect',
  },
  setCurrentMobileLayout: (layout) => ({
    type: SET_CURRENT_MOBILE_LAYOUT,
    payload: layout,
  }),
  setArchiveDialogFixed: (isFixed) => ({
    type: SET_ARCHIVE_DIALOG_FIXED,
    payload: isFixed,
  }),
  setCarBrands: {
    handle: SET_CAR_BRANDS,
    event: 'carBrands',
  },
  setOrders: {
    handle: SET_ORDERS,
    event: 'orders',
  },
  verifyAuthConfirm: {
    handle: VERIFY_AUTH_CONFIRM,
    event: 'authConfirm',
  },
  toggleAuthModal: (isOpen) => ({
    type: TOGGLE_AUTH_MODAL,
    payload: isOpen,
  }),
  toggleLogoutModalOpen: (isOpen) => ({
    type: TOGGLE_LOGOUT_MODAL,
    payload: isOpen,
  }),
  setAuthPhoneCode: (phone, code) => ({
    type: AUTH_REQUEST,
    payload: { phone, code },
  }),
  setAuthCodeIsValid: {
    handle: SET_AUTH_CODE_IS_VALID,
    event: 'buyer.authCodeValidated',
  },
  resetAuthCodeIsValid: {
    type: RESET_AUTH_CODE_IS_VALID
  },
  logouted: {
    type: LOGOUT
  },
  phoneRequestAuthFailed: {
    handle: PHONE_REQUEST_AUTH_FAILED,
    event: 'phoneAuthRequestFailed',
  },
  unblockMessageInput: {
    type: MESSAGE_UNBLOCK,
  },
  blockMessageInput: {
    type: MESSAGE_BLOCK,
  },
  setCarModel: {
    type: SET_CAR_BRAND,
  },
  openSocket: () => (dispatch) => {
    dispatch(actions.onSocketConnect);
    socket.open();
  },
  reconnectSocket: (reconnectParams) => (dispatch) => {
    Object.keys(reconnectParams).forEach((item) => {
      if (reconnectParams[item]) {
        socket.io.opts.query[item] = reconnectParams[item];
      } else {
        delete socket.io.opts.query[item];
      }
    });
    socket.disconnect();
    socket.connect();
  },
  setSelectedPvz: (offer) => ({
    type: SET_SELECTED_PVZ,
    payload: offer,
  }),
  resetSelectedPvz: { type: RESET_SELECTED_PVZ },
  selectPvz: (offer) => (dispatch) => {
    dispatch(actions.setSelectedPvz(offer));
  },
  setUserAuth: {
    handle: SET_USER_AUTH,
    event: 'buyer.auth',
  },
  setUserNewOrder: {
    handle: SET_USER_NEW_ORDER,
    event: 'ecommerceCashOrder',
    // event: 'buyer.checkoutComplete',
  },
  setRecentDialog: {
    handle: SET_RECENT_DIALOG,
    event: 'recentDialog',
  },
  listenUserAuth: () => (dispatch) => {
    dispatch(actions.setUserAuth);
    dispatch(actions.setRecentDialog);
  },
  listenUserNewOrder: () => (dispatch) => {
    dispatch(actions.setUserNewOrder);
  },
  getCarBrands: () => (dispatch) => {
    dispatch(actions.setCarBrands);
    carApi.getCarBrands();
  },
  listenPhoneRequestAuthFailed: () => (dispatch) => {
    dispatch(actions.phoneRequestAuthFailed);
  },
  fetchOrders: (phone) => (dispatch) => {
    dispatch(actions.setOrders);
    userApi.getOrdersList(phone);
  },
  sendPhoneAuthRequest: (phone, type, recaptchaResponse) => {
    userApi.sendPhoneAuthRequest(phone, type, recaptchaResponse);
  },
  resetAuthCodeValidation: () => (dispatch) => {
    dispatch(actions.resetAuthCodeIsValid);
  },
  confirmPhoneAuth: (phone, code) => (dispatch) => {
    dispatch(actions.setAuthCodeIsValid);
    dispatch(actions.setAuthPhoneCode(phone, code));
  },
  logout: () => (dispatch) => {
    dispatch(actions.logouted);
    setTimeout(() => { dispatch(actions.reconnectSocket({ phone: null, code: null, logout: true })); });
  }
};

export default actions;
